import { AutoCompleteMulti } from '~/components';
import { useApi, useWorkspace } from '~/contexts';
import { useIsMounted } from '~/hooks';
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';

function ContactMultiSelect({ value, initialValue, ...props }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const [defaultOptions, setDefaultOptions] = useState([]);
  const isMounted = useIsMounted();

  const handleSearch = useCallback(
    async (q) => {
      const { data } = await api.www.workspaces(workspace.id).contacts().options({ q, permission: 'edit' });

      return data;
    },
    [workspace.id, api],
  );

  useEffect(() => {
    (async () => {
      const data = await handleSearch('');
      if (!isMounted.current) return;
      setDefaultOptions(data);
    })();
  }, [handleSearch, initialValue, isMounted]);

  const handleChange = (value) => {
    // Adhere to standard HTML events
    props.onChange({ target: { name: value.name, value } });
  };

  const handleAdd = (selectedValue) => {
    if (!_.some(value, { id: selectedValue.id })) {
      handleChange([...value, selectedValue]);
    }
  };

  const handleRemove = (item) => {
    handleChange(value.filter(({ id }) => id !== item.id));
  };

  const filterOptions = (options) => options.filter((o) => !value?.some((v) => v.id === o?.id));

  const handleFilteredSearch = async (q) => {
    const options = await handleSearch(q);
    return filterOptions(options);
  };

  return (
    <AutoCompleteMulti
      defaultOptions={filterOptions(defaultOptions)}
      renderOption={(option) => option.name}
      value={value}
      onSearch={handleFilteredSearch}
      onAdd={handleAdd}
      onRemove={handleRemove}
      {...props}
    />
  );
}

export default ContactMultiSelect;
